import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
import { Loading, RightArrow, LeftArrow } from '@/ui/svg';
import { TokenChainIcon } from '@/ui/tokenImage';
import SetWalletNameDialog from './set-wallet-name-dialog';
import clsx from 'clsx';
import { useCreateWallet } from '@bitbot/model';
import { useHapticFeedback } from '@bitbot/shared/bridge';
// import InputInDialog from '../input-in-dialog';
import { useEffect, useState } from 'react';
import { isIOS } from '@/utils';
import { sendGAEvent } from '@next/third-parties/google';

export default function CreateNewWalletDialog(props: IDialogProps) {
  const {
    showSetWalletName,
    setShowSetWalletName,
    showDetail,
    setShowDetail,
    authCode,
    setAuthCode,
    createWallet,
    isCreatingWallet,
    errorMsg,
  } = useCreateWallet();
  // const { setShowInputInModal, showInputInModal } = useGlobalValueStore();
  const hapticFeedback = useHapticFeedback();
  const isIos = isIOS();
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (props.open) {
      setActive(false);
    }
  }, [props.open]);
  return (
    <>
      <Dialog {...props}>
        <div className="px-4">
          <div className="text-center text-lg font-bold">
            Create new wallet
          </div>
          {/* {showInputInModal && (
            <InputInDialog
              value={authCode}
              setValue={setAuthCode}
              placeholder="Enter 6-digit code"
            />
          )} */}
          <div className="px-4 py-3 rounded-2xl bg-tertiary flex flex-col mt-5 overflow-hidden">
            <div className="flex items-center gap-3">
              <TokenChainIcon
                name="base"
                src="/chain/base.svg"
                className="w-9 h-9"
              />
              <div className="flex flex-col">
                <div className="text-lg font-semibold leading-[1.5] tracking-xthin flex items-center gap-[0.375rem]">
                  Base wallet
                  <div className="text-xs bg-[#210784] px-[0.375rem] rounded-[0.25rem] flex items-center h-5 font-normal">
                    Keyless
                  </div>
                </div>
                <div
                  onClick={() => setShowDetail(!showDetail)}
                  className="text-sm text-tertiary leading-4 flex items-center cursor-pointer"
                >
                  Show detail
                  <RightArrow
                    className={clsx(
                      showDetail ? '-rotate-90' : 'rotate-90',
                    )}
                  />
                </div>
              </div>
            </div>
            <div
              className={clsx(
                'grid transition-[grid-template-rows] duration-200 ease-linear',
                showDetail ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
              )}
            >
              <div className="flex flex-col gap-3 min-h-0">
                <div className="text-xs tracking-thin pt-3">
                  <div>Keyless Smart Contract Wallets</div>
                  <div className="text-secondary mt-1">
                    Bitbot provides a secure and seamless trading
                    experience with wallets uniquely linked to your
                    Telegram ID.
                  </div>
                </div>
                <hr className="border-primary" />
                <div className="text-xs tracking-thin">
                  <div>Configurable with Master Wallet</div>
                  <div className="text-secondary mt-1">
                    Configure trading permissions and transfer wallet
                    ownership to a different Telegram ID using your own EOA
                    wallet as the master wallet.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className={clsx(
              'transition-[height] duration-200 ease-linear',
              showDetail ? 'h-[0px]' : 'h-[60px]',
            )}
          ></div>
          <div className="font-semibold leading-[28px] text-sm mt-8">
            Authenticator app
          </div>
          <div
            onClick={() => {
              // setShowInputInModal(true);
              setActive(true);
            }}
            className={clsx(
              'bg-transparent outline-none mt-3 border-[1px] w-full rounded-2xl flex-grow py-3 pl-4 pr-8',
              authCode === '' ? 'text-quaternary' : '',
              errorMsg !== '' ? 'border-red-accent' : 'border-white',
            )}
          >
            {authCode === '' ? 'Enter 6-digit code' : authCode}
          </div>
          <div className="text-red-accent h-8 text-sm flex items-center justify-start">
            {errorMsg}
          </div>
          <div
            className={clsx(
              active ? 'h-[240px]' : 'h-0',
              'transition-[height] duration-240 overflow-hidden',
            )}
          >
            <div className="grid grid-cols-3 items-center justify-center font-semibold text-4xl pb-12">
              {[
                '1',
                '2',
                '3',
                '4',
                '5',
                '6',
                '7',
                '8',
                '9',
                '',
                '0',
                'arrow',
              ].map((item, index) => {
                return (
                  <div
                    onClick={() => {
                      if (isIos) return;
                      if (item === 'arrow') {
                        if (authCode.length > 0) {
                          setAuthCode(
                            authCode.substring(0, authCode.length - 1),
                          );
                        }
                      } else {
                        if (authCode.length < 6) {
                          if (item === 'arrow') {
                            if (authCode.length > 0) {
                              setAuthCode(
                                authCode.substring(0, authCode.length - 1),
                              );
                            }
                          } else if (item !== '') {
                            setAuthCode(authCode + item);
                          }
                        }
                      }
                      hapticFeedback?.impactOccurred('light');
                    }}
                    onTouchStart={() => {
                      if (isIos) {
                        if (item === 'arrow') {
                          if (authCode.length > 0) {
                            setAuthCode(
                              authCode.substring(0, authCode.length - 1),
                            );
                          }
                        } else {
                          if (authCode.length < 6) {
                            if (item === 'arrow') {
                              if (authCode.length > 0) {
                                setAuthCode(
                                  authCode.substring(
                                    0,
                                    authCode.length - 1,
                                  ),
                                );
                              }
                            } else if (item !== '') {
                              setAuthCode(authCode + item);
                            }
                          }
                        }
                        hapticFeedback?.impactOccurred('light');
                      }
                    }}
                    className="flex items-center justify-center cursor-pointer select-none p-2"
                    key={index}
                  >
                    {item !== 'arrow' ? (
                      item
                    ) : (
                      <LeftArrow className="opacity-60" />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="">
            <Button
              onClick={() => {
                if (authCode.length === 6) {
                  createWallet();
                  sendGAEvent('event', 'click_add_wallet_create');
                }
              }}
              size="sm"
              type={
                authCode.length === 6 && !isCreatingWallet
                  ? 'primary'
                  : 'disabled'
              }
            >
              {isCreatingWallet ? (
                <>
                  Creating Wallet&nbsp;&nbsp;
                  <Loading className="w-5 h-5" />
                </>
              ) : (
                'Create'
              )}
            </Button>
          </div>
        </div>
      </Dialog>

      <SetWalletNameDialog
        open={showSetWalletName}
        toggle={setShowSetWalletName}
        hideCloseIcon
      />
    </>
  );
}
